module.exports = __webpack_public_path__ + "img/404.2b243f4b.gif";